import React from 'react';

import { cn } from '@/utils/classname';

interface WorkflowSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

/**
 * Animated spinner indicating workflow is in progress.
 * Displayed at bottom of TraceDrawer while workflow runs.
 */
export const WorkflowSpinner: React.FC<WorkflowSpinnerProps> = ({
  className,
  size = 'md',
  label = 'Workflow in progress...',
}) => {
  const sizeClasses = {
    sm: 'text-[20px]',
    md: 'text-[32px]',
    lg: 'text-[48px]',
  };

  return (
    <div
      className={cn('flex items-center justify-center gap-3 py-4', className)}
    >
      <div className={cn('text-chariot-brand-primary', sizeClasses[size])}>
        <svg width="1em" height="1em" viewBox="0 0 50 50">
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeDasharray="97.6 28"
            strokeDashoffset="0"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="1s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
      {label && (
        <span className="text-chariot-text-secondary text-sm">{label}</span>
      )}
    </div>
  );
};

export default WorkflowSpinner;
